/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum FileType {
  IMAGE = "IMAGE",
  FILE = "FILE",
}

export const FileTypeDisplay: Record<FileType, string> = {
  [FileType.IMAGE]: "Image",
  [FileType.FILE]: "File",
};
